<template>
  <BasePage :pageTitle="lessonName" back-button show-menu show-footer>
    <div v-if="isLoading" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="ms-2">{{ __DICT__.loading }}</span>
    </div>

    <template v-if="lesson">
      <!-- Bridge action: quick link to register attendance -->
      <div class="d-flex gap-2 mb-3">
        <button class="btn btn-primary btn-sm flex-fill" @click="router.push({name: 'ScanLesson', params: {lessonId: route.params.lessonId}})">
          <IconScan class="icon me-1" :size="16" />
          {{ isWorkshop ? (__DICT__.actionMenu.registerWorkshop || 'Register Workshop') : (__DICT__.actionMenu.registerLesson || 'Register Lesson') }}
        </button>
      </div>
      <LessonDetailsCard v-if="!isWorkshop" :lesson="lesson"></LessonDetailsCard>
      <LessonDetailsCard v-if="isWorkshop" :title="__DICT__.workshopDetails" :lesson="lesson"></LessonDetailsCard>
      <PaxAllocation
          :title="__DICT__.participants"
          :inhabitants="participants"
          :capacity="lesson.capacity"
          :show-capacity="false"
          show-count
          show-brand
      ></PaxAllocation>
    </template>

    <div v-else class="alert alert-important alert-danger" role="alert">
      {{ __DICT__.lessonNotFound }}
    </div>
  </BasePage>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { IconScan } from '@tabler/icons-vue'
import { useWeekStore } from '@/stores/week.js'
import BasePage from "@/components/BasePage.vue"
import PaxAllocation from "@/components/PaxAllocation.vue"
import LessonDetailsCard from "@/components/LessonDetails.vue"

const route = useRoute()
const router = useRouter()
const weekStore = useWeekStore()
const isLoading = ref(true)
const weekData = ref([])
const lesson = ref(null)

const props = defineProps({
  isWorkshop: {
    type: Boolean,
    default: false
  }
});

const lessonName = computed(() =>
    lesson.value ? `${lesson.value.group} - ${lesson.value.times}` : __DICT__.lesson
)

const participants = computed(() =>
    weekData.value.filter(passenger =>
        passenger.allocPlaces?.some(place =>
            place.lessons?.reference.split('-')[2] === route.params.lessonId
        )
    )
)

onMounted(async () => {
  try {
    weekData.value = await weekStore.weekData
    const firstParticipant = weekData.value.find(passenger =>
        passenger.allocPlaces?.some(place =>
            place.lessons?.reference.split('-')[2] === route.params.lessonId
        )
    )
    lesson.value = firstParticipant?.allocPlaces.find(
        place => place.lessons
    )?.lessons || null
  } catch (error) {
    console.error('Error loading lesson data:', error)
  } finally {
    isLoading.value = false
  }
})
</script>
